import React, { useEffect, useState } from 'react';
import MainContainer from '../components/MainContainer';
import Tabs from '../components/Tabs';

function ServicesPage() {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsVisible(true);
        }, 300);
        return () => clearTimeout(timer);
    }, []);
    return (
        <MainContainer>
            <div
                className={`transition-opacity duration-1000 ${isVisible ? 'opacity-100' : 'opacity-0'}`}
            >
                <Tabs />
            </div>
        </MainContainer>
    );
}

export default ServicesPage;
